import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formSubmittedContainer: {
            margin: 'auto',
            width: '40%',
            height: '50%',
            minHeight: 480,
            minWidth: 700,
            background: '#ffffff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: 4,
        },
        formSubmittedTitle: {
            color: '#4F4F4F',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '36px',
            lineHeight: '42px',
            textAlign: 'center',
        },
        formSubmittedSubtitle: {
            color: '#828282',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: 500,
            fontSize: '18px',
            lineHeight: '21px',
            textAlign: 'center',
            marginTop: 16,
        },
        formSubmittedIconContainer: {
            marginTop: 16,
        },
        formSubmittedIcon: {
            fontSize: 100,
        },
    }),
);
